/**
 * @module DiagnosisFeatures
 */

import Component from '../base/Component';
import './styles.css';

import '../../images/sprite/check_rounded.svg';
import '../../images/sprite/lock_simple.svg';
import '../../images/sprite/delivery_box.svg';
import '../../images/sprite/info.svg';

/**
 * Особенности магазина в диагностике
 */
export default class DiagnosisFeatures extends Component {
    static className = 'diagnosis-features';
}
